$(document).ready(function(){
    $('.pot-slider').slick({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 3000,
      slidesToShow: 12,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: "linear",
      responsive: [
        {
          breakpoint: 620,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1
          }
        }
      ]
    });
});